module.exports = __webpack_public_path__ + "img/qrCode.e3565af0.png";